import React, { useEffect, useState } from "react";
import Map from "./Map";
import { EsriConfig } from "../models/Client";
import { MapItem } from "../arcgisUtils";
import { Project } from "../models/Project";
import locationService from "../LocationService";
import "./PermitBoundariesTab.css";
import MenuOnMap from "./MenuOnMap";
import { ArcGisMapConfig } from "../models/ArcGisMapConfig";
import { Area } from "../models/Area";
import { createBoundryMapItem, createProjectBoundaries } from "../boundaryUtils";

interface PermitBoundariesProps {
    esriConfig: EsriConfig;
    areas?: Area[];
    isReadOnly: boolean;
    project?: Project;
    arcgisToken?: string;
}

const PermitBoundariesTab: React.FC<PermitBoundariesProps> = ({
    esriConfig,
    areas,
    isReadOnly,
    project,
    arcgisToken,
}) => {
    const [items, setItems] = useState<MapItem[]>([]);
    const [points, setPoints] = useState<any[]>([]);

    const mapConfig = {
        authAppId: process.env.REACT_APP_ARCGIS_APP_ID,
        portalUrl: process.env.REACT_APP_ARCGIS_PORTAL_URL,
    } as ArcGisMapConfig;

    useEffect(() => {
        locationService
            .getCurrentPosition()
            .then((position) => {
                setPoints([
                    {
                        geometry: {
                            type: "point",
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        },
                    },
                ]);
            })
            .catch((error) => {
                console.warn("Could not get current location:", error);
                // Continue without user location - this is not critical for the map to function
            });
    }, []);

    useEffect(() => {
        if (project && areas) {
            const projectBoundaries = createProjectBoundaries(project);
            const initialItems = projectBoundaries ? [projectBoundaries] : [];
            setItems(initialItems);
            points.forEach((point) => setItems((prev) => [...prev, point]));
            areas.map((b, i) => setItems((prev) => [...prev].concat(createBoundryMapItem(i.toString(), true, b))));
        }
    }, [project, areas, points]);

    return (
        <>
            <Map mapConfig={mapConfig} token={arcgisToken} webMapItemId={esriConfig.webMapItemId} items={items} />
            <MenuOnMap areas={areas} />
        </>
    );
};

export default PermitBoundariesTab;
